import { Getters } from 'vuex-smart-module';
import CompanyUserStaffState from './state';

export default class CompanyUserStaffGetters extends Getters<CompanyUserStaffState> {
  get current_user_company() {
    return this.state.current_user_company;
  }
}
